import { render, staticRenderFns } from "./DetalhesAnalise.vue?vue&type=template&id=3fdcfe52"
import script from "./DetalhesAnalise.vue?vue&type=script&lang=js"
export * from "./DetalhesAnalise.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAnalise.vue?vue&type=style&index=0&id=3fdcfe52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports